// extracted by mini-css-extract-plugin
export default {"ResizableDiv":"ResizableDiv_ResizableDiv__fkoDT","container":"ResizableDiv_container__quaIG","resizer":"ResizableDiv_resizer__gb+O+","overlay":"ResizableDiv_overlay__NyaGD"};